import { $fetch, $post, $put } from '@/services/axios';

export function add(data) {
  return $put(`company/news`, data);
}

export function fetch(data) {
  return $fetch(`company/news`, data);
}

export function validate(data) {
  return $post(`company/news/validate`, data);
}

export function edit(data) {
  return $post(`company/news/${data.id}`, data);
}
